import React from 'react';
import PropTypes from 'prop-types';
import without from 'lodash/without';
import DropdownMenu from '@radix-ui/react-dropdown-menu';
import Check from 'common/icons/Check';
import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';
import { useSessions } from 'common/components/TouchpointEditor/contexts/SessionsContext';
import ChevronRight from 'common/icons/ChevronRight';
import {
    StyledDropdownSubContent,
    StyledDropDownMenuSubTrigger,
    CheckboxSubItem,
    CheckboxIndicator,
    CheckboxFrame,
    Filterlabel,
    FilterIndicator,
} from './SessionFilter.styles';

export default function SessionDatesSubFilter({
    backgroundColor,
    backgroundColorHover,
    fontColor,
    fontSize,
    fontFamily,
    iconColor,
    borderColor,
    displayLabel,
}) {
    const {
        theme: { activeFonts, colors },
    } = useTouchpointData();
    const sessions = useSessions();

    const onFilteredDateSelect = (dateName) => {
        const updatedSessionDateFilterIds = sessions.filters.dates.includes(dateName)
            ? without(sessions.filters.dates, dateName)
            : sessions.filters.dates.concat(dateName);

        sessions.filters.setDates(updatedSessionDateFilterIds);
    };
    const sessionFiltersArray = sessions.uniqueDates || [];
    const dates = sessionFiltersArray.map((date) => {
        const checked = sessions.filters.dates.includes(date);
        return (
            <CheckboxSubItem
                key={date}
                checked={checked}
                $backgroundColorHover={colors[backgroundColorHover]}
                $borderColor={borderColor}
                onCheckedChange={() => onFilteredDateSelect(date)}
                onSelect={(e) => e.preventDefault()}
            >
                <CheckboxFrame $iconColor={iconColor}>
                    <CheckboxIndicator>
                        <Check />
                    </CheckboxIndicator>
                </CheckboxFrame>
                {date}
            </CheckboxSubItem>
        );
    });

    return (
        <DropdownMenu.Sub>
            <StyledDropDownMenuSubTrigger
                $fontColor={colors[fontColor]}
                $backgroundColor={colors[backgroundColor]}
                $fontSize={fontSize}
                $fontFamily={activeFonts[fontFamily]}
                $backgroundColorHover={colors[backgroundColorHover]}
                $iconColor={iconColor}
                $borderColor={borderColor}
            >
                <Filterlabel>
                    {displayLabel}
                    {sessions.filters.dates?.length > 0 ? (
                        <FilterIndicator $backgroundColor={colors[fontColor]} $fontColor={colors[backgroundColor]}>
                            {sessions.filters.dates?.length}
                        </FilterIndicator>
                    ) : null}
                </Filterlabel>
                <ChevronRight />
            </StyledDropDownMenuSubTrigger>
            <StyledDropdownSubContent
                $fontColor={colors[fontColor]}
                $backgroundColor={colors[backgroundColor]}
                $fontSize={fontSize}
                $fontFamily={activeFonts[fontFamily]}
                $backgroundColorHover={colors[backgroundColorHover]}
            >
                {dates}
            </StyledDropdownSubContent>
        </DropdownMenu.Sub>
    );
}

SessionDatesSubFilter.propTypes = {
    backgroundColor: PropTypes.number.isRequired,
    backgroundColorHover: PropTypes.number.isRequired,
    fontColor: PropTypes.number.isRequired,
    fontSize: PropTypes.number.isRequired,
    fontFamily: PropTypes.number.isRequired,
    displayLabel: PropTypes.string.isRequired,
    iconColor: PropTypes.string.isRequired,
    borderColor: PropTypes.string.isRequired,
};
